import React, { useEffect } from 'react';
import R2CalibrationActions from 'views/bluviu-nutrition/features/calibrations/components/edit-calibration/bluviu-nutrition-r2/r2-calibration-actions';
import R2CalibrationFeedProgram from 'views/bluviu-nutrition/features/calibrations/components/edit-calibration/bluviu-nutrition-r2/r2-calibration-feed-program';
import R2CalibrationInformation from 'views/bluviu-nutrition/features/calibrations/components/edit-calibration/bluviu-nutrition-r2/r2-calibration-information';
import R2CalibrationProgress from 'views/bluviu-nutrition/features/calibrations/components/edit-calibration/bluviu-nutrition-r2/r2-calibration-progress';
import R2CalibrationStatistics from 'views/bluviu-nutrition/features/calibrations/components/edit-calibration/bluviu-nutrition-r2/r2-calibration-statistics';
import RunR2Calibration from 'views/bluviu-nutrition/features/calibrations/components/edit-calibration/bluviu-nutrition-r2/run-r2-calibration';
import { useCalibrationState } from 'views/bluviu-nutrition/features/calibrations/context/calibration-context';
import { CalibrationState } from 'views/bluviu-nutrition/features/calibrations/types/calibration-state.enum';
import R2CalibrationInputs from './bluviu-nutrition-r2/r2-calibration-inputs';
import TemperatureLocation from './temperature-location';
import Paper from 'components/paper';
import { Box } from '@mui/material';

const EditR2Calibration = () => {
  const {
    r2CalibrationQuery: { data: calibration, isLoading },
    r2CalibrationStatusQuery: { refetch },
  } = useCalibrationState();

  useEffect(() => {
    if (calibration?.state === CalibrationState.SUBMITTED) {
      refetch();
    }
  }, [calibration]);

  return (
    <Box display={'flex'} flexDirection={'column'} gap={4}>
      <R2CalibrationProgress />
      <R2CalibrationStatistics />
      <Paper
        transparent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 4,
        }}>
        <R2CalibrationActions />
        <R2CalibrationInformation />
        <TemperatureLocation />
        <R2CalibrationInputs />
        <R2CalibrationFeedProgram />
        <RunR2Calibration />
      </Paper>
    </Box>
  );
};

export default React.memo(EditR2Calibration);
